import AuthDialog from "../../../../public_html/src/js/components/Auth/AuthDialog"
import useragent from '../../../../public_html/src/js/common/useragent'
import jQuery from 'jquery'
import 'slick-carousel'

const $ = jQuery

let popoverShown = false

const horizontalScrollCallback = (event: WheelEvent, element: HTMLElement, amount: number) => {
  event.preventDefault()
  const direction = event.deltaY * -amount
  let position = element.scrollLeft
  position += direction > 0 ? -amount : amount
  element.scrollTo({
    left: position,
    behavior: 'smooth'
  })
}

const hScroll = (element: HTMLElement, amount: number = 120) => {
  if (useragent.isWebKit) {
    element.addEventListener('mousewheel', (event: WheelEvent) => horizontalScrollCallback(event, element, amount))
  } else {
    element.addEventListener('wheel', (event) => horizontalScrollCallback(event, element, amount))
  }
}

/* Trigger when page is ready */
$(() => {
  $('.mousemove-unit').each(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }
    const _this = $(this)
    _this.on('mouseneter', () => {
      _this.removeClass("mousemove-unit_return")
      _this.addClass("mousemove-unit_entered")
      setTimeout(() => {
        _this.removeClass("mousemove-unit_entered")
      }, 200)
    })
    _this.on('mousemove', (event) => {
      const parentHeight = _this.height()
      const parentWidth = _this.width()
      const relX = event.pageX - _this.offset().left
      const relY = event.pageY - _this.offset().top
      const mousePercentsX = relX / parentWidth * 100 - 50
      const mousePercentsY = relY / parentHeight * 100 - 50
      const x1 = 1 - Math.abs(mousePercentsX) / 10000
      const x3 = 0 //смещают кнопку видео под слой, делая ее некликабельной
      const x4 = mousePercentsX / 2000000
      const x5 = -mousePercentsX / 1000000
      const x6 = 1 - Math.abs(mousePercentsY) / 10000
      const x7 = 0 //смещают кнопку видео под слой, делая ее некликабельной
      const x8 = mousePercentsY / 2000000
      const x9 = 0
      const x10 = 0
      const x11 = 1 - Math.abs(mousePercentsX) / 10000 - Math.abs(mousePercentsY) / 10000
      const x12 = 0
      const x13 = 20 * (mousePercentsX / 50)
      //const x13=0
      const x14 = 20 * (mousePercentsY / 50)
      //const x14=0
      const x15 = 0
      const x16 = 1
      const transformMatrix = `${x1},0,${x3},${x4},${x5},${x6},${x7},${x8},${x9},${x10},${x11},${x12},${x13},${x14},${x15},${x16}`

      _this.css("transform", `matrix3d(${transformMatrix})`)
    })
    _this.on('mouseleave', () => {
      _this.addClass("mousemove-unit_return")
    })
  })


  // Your functions go here
  $(document).on('keyup', (e) => {
    if (e.key === "Escape") {
      $('.popup').removeClass("popup_active")
      $("html").removeClass("popup_open")
      $("body").removeClass("popup_open")
      $('#video').empty()
    }
  })

  $(".pagination-wrap").each(function () {
    const _this = $(this)
    const wrapWidth = _this.width()
    const inner = _this.find(".pagination-wrap-inner")
    const unitsAmount = _this.find(".pagination-unit").length
    const unitWidth = _this.find(".pagination-unit").outerWidth(true)
    const innerWidth = unitsAmount * unitWidth

    inner.css("width", `${innerWidth}px`)
    const currentUnit = _this.find(".pagination-unit_current").index() + 1
    $('.pagination-wrap').animate({ scrollLeft: currentUnit * unitWidth - wrapWidth / 2 - unitWidth / 2 }, 800)
  })

  const paginationWrap = $('.pagination-wrap').get(0)

  if (paginationWrap) {
    if (useragent.isMacOS) {
      hScroll(paginationWrap, 30) // You can pass (optionally) scrolling amount
    } else {
      hScroll(paginationWrap, 150) // You can pass (optionally) scrolling amount
    }
  }

  $(".nominees-unit-title").on("mouseover", function () {
    if (HTMLElement.prototype.hasOwnProperty("popover") && !popoverShown) {
      document.querySelectorAll('.nominees-unit-popup').forEach(item => {
        // @ts-ignore
        item.popover = 'manual'
        // @ts-ignore
        item.showPopover()
      })
      popoverShown = true
    }
    const _this = $(this)
    _this.on("mousemove", (evt) => {
      const popup = _this.find(".nominees-unit-popup")
      let x = evt.pageX - _this.offset().left
      let y = evt.pageY - _this.offset().top
      let position = 'absolute'
      if (HTMLElement.prototype.hasOwnProperty("popover")) {
        x = evt.clientX
        y = evt.clientY
        position = 'fixed'
      }
      const popupX = x + 20
      const popupY = y + 20
      popup.css({
        'top': `${popupY}px`,
        'left': `${popupX}px`,
        'position': position
      })
    })
  })

  $(".slides").each(function () {
    const _this = $(this)
    const slider = _this.find(".slides-body-wrap")
    const header = _this.find(".slides-header")
    const initSlide = header.find(".slides-header-unit_active").index()
    slider.on('beforeChange', (_event: any, _slick: any, _currentSlide: any, nextSlide: any) => {
      const slidesHeaderUnit = header.find(".slides-header-unit")
      slidesHeaderUnit.removeClass("slides-header-unit_active")
      slidesHeaderUnit.eq(nextSlide).addClass("slides-header-unit_active")
    })

    // @ts-ignore
    slider.slick({
      initialSlide: initSlide,
      fade: true,
      adaptiveHeight: true,
      arrows: false,
      draggable: false,
      accessibility: false,
      scroll: false,
      swipe: false,
      touchMove: false,
    })
  })
  $(".slides-header-unit").on('click', function () {
    const _this = $(this)
    const index = _this.index()
    const parent = _this.parents(".slides")
    const slider = parent.find(".slides-body-wrap")
    // noinspection JSUnresolvedReference
    // @ts-ignore
    slider.slick("slickGoTo", index, false)
  })
  $(".header-burger").on('click', function () {
    $(this).toggleClass("header-burger_active")
    $(".menu-mobile").toggleClass("menu-mobile_active")
    $("html").toggleClass("popup_open")
    $("body").toggleClass("popup_open")
  })
  $('.openPopup').on('click', () => {
    $("html").addClass("popup_open")
    $("body").addClass("popup_open")
  })
  $(".openPopup_video").on('click', function () {
    $(".popup_video").addClass("popup_active")
    const code = youtube_parser($(this).attr('data-video')) || ''
    const src = ('https://www.youtube.com/embed/CODE?enablejsapi=1&autoplay=1&origin=' + window.location.origin).replace('CODE', code)

    $('#video').html(`<iframe id="video" src="${src}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>`)
  })
  $(".openPopup_register").on('click', () => {
    $(".popup_register").addClass("popup_active")
  })
  $('.popup-close').on('click', function () {
    $(this).parents(".popup").removeClass("popup_active")
    $("html").removeClass("popup_open")
    $("body").removeClass("popup_open")
    $('#video').empty()
  })
  $('.popup').on('click', function () {
    $('#video').empty()
    $(this).removeClass("popup_active")
    $("html").removeClass("popup_open")
    $("body").removeClass("popup_open")
  })
  $('.popup-wrap').on('click', (e) => {
    e.stopPropagation()
  })

  $(".games-unit-button").on('click', function () {
    const _this = $(this)
    const game = _this.parents(".vote-unit")

    $.post({
      // @ts-ignore
      url: URL_MAKE_VOTE,
      data: {
        nominationId: _this.attr('data-nomination'),
        gameId: _this.attr('data-game')
      },
      dataType: 'json',
      success: function (resp: {
        ok: boolean
        end: boolean
      }) {
        if (resp.ok === true) {
          document.querySelectorAll('.vote-unit_selected').forEach(element => {
            element.classList.remove('vote-unit_selected')
          })
          game.addClass("vote-unit_selected")
          $(".pagination-unit_current").addClass("pagination-unit_done").removeClass("pagination-unit_current")
        } else if (resp.end) {
          // noinspection TypeScriptValidateJSTypes
          $('.vote-unit').not('.vote-unit_selected').addClass('vote-unit_faded')
        } else {
          $(".vote-unit").removeClass("vote-unit_faded")
        }
      },
      error: function (err: {
        status: number
      }) {
        $(".vote-unit").removeClass("vote-unit_faded")
        if (err.status === 403) {
          // noinspection JSIgnoredPromiseFromCall
          AuthDialog.show()
        }
      }
    })
  })
})


const tag = document.createElement('script')
tag.src = "https://www.youtube.com/iframe_api"
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

function showAnimatedElements() {
  function Utils() {

  }

  Utils.prototype = {
    constructor: Utils,
    isElementInView: (element: HTMLElement, fullyInView: boolean) => {
      const pageTop = $(window).scrollTop()
      const pageBottom = pageTop + $(window).height()
      const elementTop = $(element).offset().top
      const elementBottom = elementTop + $(element).height()

      if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom))
      } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop))
      }
    }
  }

  const utils = new Utils()

  if (screen.width <= 650) {
    return
  }

  let delay = 0
  $(".animated-element_moved").each(function () {
    const animatedElement = $(this)

    const elementInView = utils.isElementInView(animatedElement, false)
    if (elementInView) {
      delay = delay + 200
      setTimeout(() => {
        animatedElement.removeClass("animated-element_moved")
      }, delay)
    }


  })
}

function youtube_parser(url: string) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
  const match = url.match(regExp)
  return (match && match[7].length === 11) ? match[7] : false
}

$(() => {
  setTimeout(showAnimatedElements, 300)
})
$(window).on("load resize", () => {
  const windowWidth = $(window).outerWidth()
  if (windowWidth < 651) {
    $(".results-unit").each(function () {
      const _this = $(this)
      const number = _this.find(".games-unit-number")
      _this.find(".results-unit-title").prepend(number)
    })
  } else {
    $(".results-unit").each(function () {
      const _this = $(this)
      const number = _this.find(".games-unit-number")
      _this.find(".games-unit-image").prepend(number)
    })
  }
  $(".pagination-wrap").each(function () {
    const _this = $(this)
    const inner = _this.find(".pagination-wrap-inner")
    const unitsAmount = _this.find(".pagination-unit").length
    const unitWidth = _this.find(".pagination-unit").outerWidth(true)
    const innerWidth = unitsAmount * unitWidth
    inner.css("width", `${innerWidth}px`)
  })
})


$(window).on("scroll", showAnimatedElements)
window.addEventListener("orientationchange", showAnimatedElements, false)
$(window).on('resize', showAnimatedElements)

$(() => {
  if (window.navigator.share && !useragent.isDesktopOS) {
    document.querySelectorAll('.likely').forEach(container => {
      container.innerHTML = ''
      const button = document.createElement('div')
      button.innerHTML = '<span class="likely__button keep-mobile" style="padding: 1px 4px">Поделиться</span>'
      button.classList.add('likely__widget')
      button.addEventListener('click', () => {
        // noinspection JSIgnoredPromiseFromCall
        window.navigator.share({
          title: document.querySelector('title').innerText,
          text: document.querySelector('meta[name="description"]')?.getAttribute('content'),
          url: window.location.href
        })
      })
      container.appendChild(button)
    })
  }
})
